<template>
    <div class="layout-item">
        <div class="head">
            <div class="head-title">
                <h4>{{item.name}}</h4>
            </div>
        </div>
        <div class="content" @click="layoutShop(item.ws_id)">
            <img :src="item.thumb" :alt="$t('a_noLayoutImg')">
        </div>
    </div>
</template>
<script>
export default {
    props: ['item'],
    methods: {
        layoutShop(ws_id) {
            this.$router.replace({ path: `/layoutshop/${ws_id}` });
        }
    }
};
</script>
<style lang="less">
.layout-item {
    .head {
        padding: 10px;
        border-bottom: 1px solid #e3e3e3;
        .head-title {
            h4 {
                font-size: 16px;
            }
        }
    }
    .content {
        padding: 10px;
        height: 300px;
        width: 100%;
        text-align: center;
        img {
            max-width: 100%;
            max-height: 100%;
        }
    }
}
</style>





// WEBPACK FOOTER //
// src/views/layout/components/item.vue